import type React from 'react';
import { cn } from '../../lib/utils';

interface SplitPaneLayoutProps {
  children: React.ReactNode; // The main list / table content
  sidePanelContent: React.ReactNode; // The sidebar content (rendered via nested Outlet)
  isOpen: boolean; // Whether the sidebar is open
  onClose: () => void; // Close handler
  mainPaneClassName?: string;
}

export function SplitPaneLayout({
  children,
  sidePanelContent,
  isOpen,
  onClose,
  mainPaneClassName,
}: SplitPaneLayoutProps) {
  return (
    <div className="relative overflow-hidden h-screen">
      {/* Left / Main pane */}
      <div
        className={cn(
          'flex-1 h-full transition-all duration-300 ease-in-out scrollbar-thin',
          mainPaneClassName || 'overflow-y-auto px-6 py-6',
          isOpen ? 'lg:mr-[420px] xl:mr-[480px]' : 'mr-0'
        )}
      >
        {children}
      </div>

      {/* Right / Sidebar pane (Sideload) */}
      <div
        className={cn(
          'fixed top-0 right-0 bottom-0 z-40 flex flex-col bg-background border-l shadow-2xl transition-all duration-300 ease-in-out transform',
          'w-full sm:w-[480px] lg:w-[420px] xl:w-[480px]',
          isOpen ? 'translate-x-0' : 'translate-x-full'
        )}
      >
        {sidePanelContent}
      </div>

      {/* Mobile backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/20 backdrop-blur-xs sm:hidden"
          onClick={onClose}
        />
      )}
    </div>
  );
}
